import {
  type BaseState,
  HOST_QUERY_KEY,
  metaApiInstance,
  type ServiceAppState,
} from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

import { CookieKeyMap } from '../../constants/cookie';
import { parseCookies } from '../../utils/cookie/parseCookies';
import { getRequestUrlData } from '../../utils/getRequestUrlData';
import { parsePathname } from '../../utils/parsePathname';
import { getServerTraceHttpTimingOptions } from '../../utils/serverTrace/store';

import type { Guard } from '../../types';

/**
 * 초기 진입 시 fetchUserPreference를 호출하고 쿼리에 저장하여 CSR에서 사용할 수 있도록 하는 가드
 * @description
 * - 리다이렉트/에러 처리 없이 fetch 후 쿼리 저장만 수행
 */
export const determineUserPreferenceGuard: Guard<ServiceAppState & BaseState> = async ({
  context,
  queryClient,
}) => {
  const { resolvedUrl } = context;
  const { cookie } = getRequestUrlData(context);
  const cookies = parseCookies(cookie || '');
  const cookieToken = cookies[CookieKeyMap.TOKEN_KEY] || '';

  const { fetchUserPreference } = metaApiInstance({
    token: cookieToken,
    ...getServerTraceHttpTimingOptions(context.req, 'config'),
  });

  const { serviceKeyword } = parsePathname(resolvedUrl);

  if (!serviceKeyword) {
    return { status: STATUS_CODE.OK };
  }

  await queryClient.fetchQuery({
    queryKey: [HOST_QUERY_KEY.GET_USER_PREFERENCE, { serviceKeyword }],
    queryFn: () => fetchUserPreference({ serviceKeyword }),
  });

  return { status: STATUS_CODE.OK };
};

determineUserPreferenceGuard.displayName = 'determineUserPreferenceGuard';
